import React from "react";
import ErrorState from "./ErrorState";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <ErrorState h1="An Error Occured" />
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
